import type { JSX } from 'react';
import { memo } from 'react';

import Layout from './Layout';

export const LayoutContainer = ({
  children,
  leftSidebar,
  rightSidebar,
}: {
  children?: JSX.Element;
  leftSidebar?: JSX.Element | null;
  rightSidebar?: JSX.Element | null;
}) => {
  return (
    <Layout leftSidebar={leftSidebar} rightSidebar={rightSidebar}>
      {children}
    </Layout>
  );
};

export default memo(LayoutContainer);
